import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

export interface GameTranslationFields {
  name: string;
  description: string;
}

export type GameTranslationsMap = Record<string, GameTranslationFields>;

@Injectable({providedIn: 'root'})
export class GameContentTranslationService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {}

  async getAll(gameId: string): Promise<GameTranslationsMap> {
    const url = `${this.toolsSrv.getApiEndpoint()}i18n/game/${gameId}`;
    return await this.http.get<GameTranslationsMap>(url).toPromise() ?? {};
  }

  async update(gameId: string, langSrc: string, field: 'name' | 'description', value: string): Promise<void> {
    const url = `${this.toolsSrv.getApiEndpoint()}i18n/game/${gameId}`;
    await this.http.patch(url, {langSrc, field, value}).toPromise();
  }
}
